import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { useIsMobile } from '../../../../hooks';
import {
  Touchable,
  BodyText,
  Stack,
  HeaderText,
  Absolute,
  ImageBox,
} from '../../../ui';
import HeroImage from './images/hero.png';
import DesktopHeroImage from './images/booking-referrals.png';

type ClientReferralHeroProps = {
  onClick: () => void;
  show?: boolean;
};

export const ClientReferralHero: React.FCWithChildren<ClientReferralHeroProps> = ({
  onClick,
  show = true,
}) => {
  const isMobile = useIsMobile();

  if (!show) {
    return null;
  }

  return (
    <Touchable onClick={onClick} testID="client-referral-hero">
      <Box
        alignItems="center"
        flex={1}
      >
        <Inline
          color={BrandColor.LightRed}
          alignItems="center"
          padding={isMobile ? 12 : 36}
          justifyContent="flex-start"
          space={8}
          paddingTop={isMobile ? 20 : 36}
          overflow="hidden"
          borderRadius={8}
          maxWidth={680}
          style={{
            /* We need to use width here to say "be as big as our container up to our max width",
             * since using min-width says "be at least this big regardless of max". Using flex
             * stretch results in left alignment but proper stretching, whereas flex center does not
             * stretch as expected, hence the need to mess with width constraints. */
            width: '100%',
          }}
          flex={1}
        >
          <Stack
            alignItems="flex-start"
            space={12}
          >
            <HeaderText level={2}>
              Better with friends!
            </HeaderText>
            {isMobile ? (
              <BodyText>
                Refer a friend and you&apos;ll
                {'\n'}
                both get 15% (up to $50)
                {'\n'}
                off when you book with a
                {'\n'}
                new pro.
              </BodyText>
            ) : (
              <BodyText color={BrandColor.Metal}>
                Refer a friend and you&apos;ll
                both get 15% (up to $50)
                {'\n'}
                off when you book with a
                new pro.
              </BodyText>
            )}

            {/* Make a "slim" button */}
            <Box
              paddingY={isMobile ? 4 : 8}
              paddingX={isMobile ? 8 : 32}
              justifyContent="center"
              alignItems="center"
              color={BrandColor.BackInBlack}
              borderRadius={4}
            >
              <BodyText
                color={BrandColor.WhiteWash}
                appearance={isMobile ? 'smaller' : 'normal'}
                weight="bold"
              >
                Share Now
              </BodyText>
            </Box>
          </Stack>
          <Absolute
            right={0}
            bottom={0}
          >
            <ImageBox
              source={isMobile ? HeroImage : DesktopHeroImage}
              width={isMobile ? 163 : 342}
              height={isMobile ? 163 : 204}
              accessibilityLabel="two friends posing"
            />
          </Absolute>
        </Inline>
      </Box>
    </Touchable>
  );
};
